import { createAction, props } from "@ngrx/store";
import { NoticeCreate2Cmd, NoticeDeleteCmd } from "@youm-front/notice/domain";

export const noticeCreate = createAction(
  "[Notice] Create",
  props<{ noticeCreateCmd: NoticeCreate2Cmd }>()
);

export const noticeDelete = createAction(
  "[Notice] Delete",
  props<{ noticeDeleteCmd: NoticeDeleteCmd }>()
);
